import { Route, Navigate, useParams, useLocation } from 'react-router-dom';
import { authRoute, lazyPage } from './routeHelpers';

/** 微调编排页已废弃，旧 URL 转到水肥作业方案 */
function RedirectIrrigationModeConfigToPlan() {
  const { designId } = useParams();
  return (
    <Navigate
      to={`/production/land/irrigation-design-rotation-plan/${designId || ''}`}
      replace
    />
  );
}

/** 作业任务页已下线，保留 query 转到农事作业总览 */
function RedirectFieldTasksToOverview() {
  const location = useLocation();
  return <Navigate to={`/production/field-work${location.search || ''}`} replace />;
}

/** 旧「苗情虫情」路由拆成苗情 / 虫情两页 */
function RedirectLegacySeedlingPestMedia() {
  const { landParcelId } = useParams();
  const location = useLocation();
  const qs = new URLSearchParams(location.search || '');
  const dest = qs.get('focus') === 'pest' ? 'pest-media' : 'seedling-media';
  const suffix = qs.toString();
  return (
    <Navigate
      to={`/production/land/${landParcelId}/${dest}${suffix ? `?${suffix}` : ''}`}
      replace
    />
  );
}
const ProductionHubPage = lazyPage(() => import('../pages/production/hub/ProductionHubPage'));
const MyFarmPage = lazyPage(() => import('../pages/production/land/MyFarmPage'));
const MyFarmHomePage = lazyPage(() => import('../pages/production/land/MyFarmHomePage'));
const FarmInsightHubPage = lazyPage(() => import('../pages/production/hub/FarmInsightHubPage'));
const PlantedCropsPage = lazyPage(() => import('../pages/production/crop/PlantedCropsPage'));
const AgriculturalMaterialsPage = lazyPage(() => import('../pages/production/support/AgriculturalMaterialsPage'));
const FieldManagementPage = lazyPage(() => import('../pages/production/field-work/FieldManagementPage'));
const AssetManagementPage = lazyPage(() => import('../pages/production/land/AssetManagementPage'));
const ComprehensiveAssetManagementPage = lazyPage(() => import('../pages/asset-management/ComprehensiveAssetManagementPage'));
const DataVisualizationPage = lazyPage(() => import('../pages/production/support/DataVisualizationPage'));
const DiseaseWarningPage = lazyPage(() => import('../pages/production/field-work/DiseaseWarningPage'));
const FertilizationManagementPage = lazyPage(() => import('../pages/production/field-work/FertilizationManagementPage'));
const MachineryOperationPage = lazyPage(() => import('../pages/production/field-work/MachineryOperationPage'));
const FieldPlanManagementPage = lazyPage(() => import('../pages/production/field-work/FieldPlanManagementPage'));
const IrrigationManagementUnifiedPage = lazyPage(() => import('../pages/production/field-work/IrrigationManagementUnifiedPage'));
const IrrigationRuleConfigPage = lazyPage(() => import('../pages/production/land/IrrigationRuleConfigPage'));
const IrrigationDesignMapPage = lazyPage(() => import('../pages/production/land/IrrigationDesignMapPage'));
const IrrigationEquipmentCatalogPage = lazyPage(() => import('../pages/production/land/IrrigationEquipmentCatalogPage'));
const IrrigationDesignRuleProfilePage = lazyPage(() => import('../pages/production/land/IrrigationDesignRuleProfilePage'));
const IrrigationFertigationPlanPage = lazyPage(() => import('../pages/production/land/IrrigationFertigationPlanPage'));
const IrrigationDesignBomPage = lazyPage(() => import('../pages/production/land/IrrigationDesignBomPage'));
const FarmEnvMonitoringPage = lazyPage(() => import('../pages/production/land/FarmEnvMonitoringPage'));
const FarmPestEcologyPage = lazyPage(() => import('../pages/production/field-work/FarmPestEcologyPage'));
const GrowthYieldAnalysisPage = lazyPage(() => import('../pages/production/crop/farm-digital/GrowthYieldAnalysisPage'));
const SmartGrowthMonitorPage = lazyPage(() => import('../pages/production/crop/growth/SmartGrowthMonitorPage'));
const LandGrowthArchivePage = lazyPage(() => import('../pages/production/crop/growth/LandGrowthArchivePage'));
const BusinessAnalysisPage = lazyPage(() => import('../pages/production/crop/farm-digital/BusinessAnalysisPage'));
const AgriCycleHubPage = lazyPage(() => import('../pages/production/crop/farm-digital/AgriCycleHubPage'));
const FarmSoilTestingPage = lazyPage(() => import('../pages/production/crop/nutrition/FarmSoilTestingPage'));
const FarmFertilizationControlPage = lazyPage(() => import('../pages/production/crop/nutrition/FarmFertilizationControlPage'));
const FarmFertilityAnalysisPage = lazyPage(() => import('../pages/production/crop/nutrition/FarmFertilityAnalysisPage'));
const FarmFertilizerPrescriptionPage = lazyPage(() => import('../pages/production/crop/nutrition/FarmFertilizerPrescriptionPage'));
const FarmFertilizerDeliveryPage = lazyPage(() => import('../pages/production/crop/nutrition/FarmFertilizerDeliveryPage'));
const FarmRemoteSensingPage = lazyPage(() => import('../pages/production/crop/farm-digital/FarmRemoteSensingPage'));
const EcoAgricultureHubPage = lazyPage(() => import('../pages/production/crop/farm-digital/EcoAgricultureHubPage'));
const SmartFarmCockpitPage = lazyPage(() => import('../pages/cockpit/smart-farm/SmartFarmCockpitPage'));
const SmartFarmParcelRealtimePage = lazyPage(() => import('../pages/cockpit/smart-farm/SmartFarmParcelRealtimePage'));
const SchemeHubPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeHubPage'));
const SchemeVersionPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeVersionPage'));
const SchemeTemplateCenterPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeTemplateCenterPage'));
const SchemeGenerateWizardPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeGenerateWizardPage'));
const SchemeEditorPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeEditorPage'));
const SchemeExportHubPage = lazyPage(() => import('../pages/production/crop/schemes/SchemeExportHubPage'));
const ProjectLedgerPage = lazyPage(() => import('../pages/production/crop/schemes/ProjectLedgerPage'));
const WarningAnalysisPage = lazyPage(() => import('../pages/production/crop/WarningAnalysisPage'));
const MaterialsInfoPage = lazyPage(() => import('../pages/production/support/MaterialsInfoPage'));
const MaterialsManagementPage = lazyPage(() => import('../pages/production/support/MaterialsManagementPage'));
const MaterialEstimatePage = lazyPage(() => import('../pages/production/crop/MaterialEstimatePage'));
const FarmProcurementHubPage = lazyPage(() => import('../pages/production/support/FarmProcurementHubPage'));
const GrainStorageManagementPage = lazyPage(() => import('../pages/production/support/GrainStorageManagementPage'));
const FieldWorkOverviewPage = lazyPage(() => import('../pages/production/field-work/FieldWorkOverviewPage'));
const FieldWorkLedgerPage = lazyPage(() => import('../pages/production/field-work/FieldWorkLedgerPage'));
const StageProtectionPlanPage = lazyPage(() => import('../pages/production/field-work/StageProtectionPlanPage'));
const CropGlobalDistributionPage = lazyPage(() => import('../pages/production/crop/CropGlobalDistributionPage'));
const CropGrowthComparisonPage = lazyPage(() => import('../pages/production/crop/CropGrowthComparisonPage'));
const DataAnalysisPage = lazyPage(() => import('../pages/production/support/DataAnalysisPage'));
const NetworkTrendAnalysisPage = lazyPage(() => import('../pages/production/support/NetworkTrendAnalysisPage'));
const AssetInfoPage = lazyPage(() => import('../pages/production/land/AssetInfoPage'));
const LandAssetInfoPage = lazyPage(() => import('../pages/production/land/LandAssetInfoPage'));
const LandDetailPage = lazyPage(() => import('../pages/production/land/land-detail/LandDetailPage.jsx'));
const TrendAnalysisPage = lazyPage(() => import('../pages/production/support/TrendAnalysisPage'));
const HistoricalDataPage = lazyPage(() => import('../pages/production/support/HistoricalDataPage'));
const DataCrawlingPage = lazyPage(() => import('../pages/production/support/DataCrawlingPage'));
const DataAnalyticsPage = lazyPage(() => import('../pages/production/support/DataAnalyticsPage'));
const GlobalMonitoringPage = lazyPage(() => import('../pages/production/support/GlobalMonitoringPage'));
const WeatherWarningPage = lazyPage(() => import('../pages/production/field-work/pest-control/WeatherWarningPage'));
const WarningReportsPage = lazyPage(() => import('../pages/production/field-work/pest-control/WarningReportsPage'));
const PreventionAdvicePage = lazyPage(() => import('../pages/production/field-work/pest-control/PreventionAdvicePage'));
const NotificationSettingsPage = lazyPage(() => import('../pages/production/field-work/pest-control/NotificationSettingsPage'));
const RealTimeMonitoringPage = lazyPage(() => import('../pages/production/field-work/pest-control/RealTimeMonitoringPage'));
const HistoricalAnalysisPage = lazyPage(() => import('../pages/production/field-work/pest-control/HistoricalAnalysisPage'));
const AssetStatisticsPage = lazyPage(() => import('../pages/production/land/AssetStatisticsPage'));
const AgriculturalMaterialPage = lazyPage(() => import('../pages/production/support/AgriculturalMaterialPage'));
const PlanningStatisticsPage = lazyPage(() => import('../pages/production/crop/PlanningStatisticsPage'));
const SowingManagementPage = lazyPage(() => import('../pages/production/field-work/SowingManagementPage'));
const WeedingManagementPage = lazyPage(() => import('../pages/production/field-work/WeedingManagementPage'));
const LandManagementHubPage = lazyPage(() => import('../pages/production/land/LandManagementHubPage'));
const GrowthCyclePage = lazyPage(() => import('../pages/production/crop/GrowthCyclePage'));
const GrowthBudgetPage = lazyPage(() => import('../pages/production/crop/GrowthBudgetPage'));
const FarmWorkHubPage = lazyPage(() => import('../pages/production/field-work/FarmWorkHubPage'));
const WarningManagementPage = lazyPage(() => import('../pages/production/field-work/WarningManagementPage'));
const PlantingPlanEntryPage = lazyPage(() => import('../pages/production/crop/PlantingPlanEntryPage'));
const CropFieldWorkProcessPage = lazyPage(() => import('../pages/production/crop/CropFieldWorkProcessPage'));
const LandMapPage = lazyPage(() => import('../pages/production/land/land-map/LandMapPage.jsx'));
const LandPlantingArchivePage = lazyPage(() => import('../pages/production/land/planting-archive/LandPlantingArchivePage.jsx'));
const LandSoilArchivePage = lazyPage(() => import('../pages/production/land/soil-archive/LandSoilArchivePage.jsx'));
const LandFarmingHistoryPage = lazyPage(() => import('../pages/production/land/farming-history/LandFarmingHistoryPage.jsx'));
const LandFieldOpsPage = lazyPage(() => import('../pages/production/land/field-ops/LandFieldOpsPage.jsx'));
const LandMediaPage = lazyPage(() => import('../pages/production/land/media/LandMediaPage.jsx'));
const SeedlingMediaPage = lazyPage(() => import('../pages/production/land/media/SeedlingMediaPage.jsx'));
const PestMediaPage = lazyPage(() => import('../pages/production/land/media/PestMediaPage.jsx'));
const LandParcelModulePlaceholderPage = lazyPage(() => import('../pages/production/land/LandParcelModulePlaceholderPage.jsx'));
const LandDashboardPage = lazyPage(() => import('../pages/production/land/dashboard/LandDashboardPage.jsx'));
const LandParcelModuleListPage = lazyPage(() => import('../pages/production/land/LandParcelModuleListPage.jsx'));
const FarmSmartDevicePage = lazyPage(() => import('../pages/production/land/FarmSmartDevicePage'));
const IrrigationNetworkAnalysisPage = lazyPage(() => import('../pages/production/land/IrrigationNetworkAnalysisPage'));
const CalendarPage = lazyPage(() => import('../pages/CalendarPage'));
const ModelListPage = lazyPage(() => import('../pages/growth-model/ModelListPage'));
const AIModelingPage = lazyPage(() => import('../pages/growth-model/AIModelingPage'));
const ModelDetailPage = lazyPage(() => import('../pages/growth-model/ModelDetailPage'));
const ModelParameterConfigPage = lazyPage(() => import('../pages/growth-model/ModelParameterConfigPage'));
export function getProductionRoutes(isAuthenticated) {
  return (
    <>
      <Route path="/production" element={authRoute(isAuthenticated, <ProductionHubPage />)} />
      <Route path="/production/land" element={authRoute(isAuthenticated, <MyFarmHomePage />)} />
      <Route
        path="/production/farm-insight-hub"
        element={authRoute(isAuthenticated, <FarmInsightHubPage />)}
      />
      <Route path="/production/land/farm-management" element={authRoute(isAuthenticated, <MyFarmPage />)} />
      <Route
        path="/production/land/irrigation-hub"
        element={<Navigate to="/production/field-work/irrigation" replace />}
      />
      <Route path="/production/land/irrigation-rule-config" element={authRoute(isAuthenticated, <IrrigationRuleConfigPage />)} />
      <Route path="/production/land/env-monitoring" element={authRoute(isAuthenticated, <FarmEnvMonitoringPage />)} />
      <Route path="/production/land/smart-device" element={authRoute(isAuthenticated, <FarmSmartDevicePage />)} />
      <Route
        path="/production/land/irrigation-network-analysis"
        element={authRoute(isAuthenticated, <IrrigationNetworkAnalysisPage />)}
      />
      <Route
        path="/production/land/irrigation-plan-ledger"
        element={<Navigate to="/production/field-work/irrigation?tab=ledger" replace />}
      />
      <Route path="/production/field-work/pest-ecology" element={authRoute(isAuthenticated, <FarmPestEcologyPage />)} />
      <Route path="/production/field-work/hub" element={authRoute(isAuthenticated, <FarmWorkHubPage />)} />
      <Route
        path="/production/land/modules/:moduleKey"
        element={authRoute(isAuthenticated, <LandParcelModuleListPage />)}
      />
      <Route
        path="/production/land/:landParcelId/map"
        element={authRoute(isAuthenticated, <LandMapPage />)}
      />
      <Route
        path="/production/land/:landParcelId/planting-archive"
        element={authRoute(isAuthenticated, <LandPlantingArchivePage />)}
      />
      <Route
        path="/production/land/:landParcelId/soil-archive"
        element={authRoute(isAuthenticated, <LandSoilArchivePage />)}
      />
      <Route
        path="/production/land/:landParcelId/farming-history"
        element={authRoute(isAuthenticated, <LandFarmingHistoryPage />)}
      />
      <Route
        path="/production/land/:landParcelId/machinery"
        element={authRoute(isAuthenticated, <MachineryOperationPage />)}
      />
      <Route
        path="/production/field-work/by-land/:landParcelId"
        element={authRoute(isAuthenticated, <LandFieldOpsPage />)}
      />
      <Route
        path="/production/land/:landParcelId/media"
        element={authRoute(isAuthenticated, <LandMediaPage />)}
      />
      <Route
        path="/production/land/:landParcelId/seedling-media"
        element={authRoute(isAuthenticated, <SeedlingMediaPage />)}
      />
      <Route
        path="/production/land/:landParcelId/pest-media"
        element={authRoute(isAuthenticated, <PestMediaPage />)}
      />
      <Route
        path="/production/land/:landParcelId/seedling-pest-media"
        element={authRoute(isAuthenticated, <RedirectLegacySeedlingPestMedia />)}
      />
      <Route
        path="/production/land/:landParcelId/dashboard"
        element={authRoute(isAuthenticated, <LandDashboardPage />)}
      />
      <Route path="/production/crop/yield-analysis" element={authRoute(isAuthenticated, <GrowthYieldAnalysisPage />)} />
      <Route path="/production/land/smart-growth-monitor" element={authRoute(isAuthenticated, <SmartGrowthMonitorPage />)} />
      <Route path="/production/land/growth-archive" element={authRoute(isAuthenticated, <LandGrowthArchivePage />)} />
      <Route path="/production/land/business-analysis" element={authRoute(isAuthenticated, <BusinessAnalysisPage />)} />
      <Route path="/production/land/agri-cycle" element={authRoute(isAuthenticated, <AgriCycleHubPage />)} />
      <Route path="/production/land/soil-testing" element={authRoute(isAuthenticated, <FarmSoilTestingPage />)} />
      <Route path="/production/land/fertilization-control" element={authRoute(isAuthenticated, <FarmFertilizationControlPage />)} />
      <Route path="/production/land/fertility-analysis" element={authRoute(isAuthenticated, <FarmFertilityAnalysisPage />)} />
      <Route path="/production/land/fertilizer-prescription" element={authRoute(isAuthenticated, <FarmFertilizerPrescriptionPage />)} />
      <Route path="/production/land/fertilizer-delivery" element={authRoute(isAuthenticated, <FarmFertilizerDeliveryPage />)} />
      <Route path="/production/land/remote-sensing" element={authRoute(isAuthenticated, <FarmRemoteSensingPage />)} />
      <Route path="/production/land/eco-agriculture" element={authRoute(isAuthenticated, <EcoAgricultureHubPage />)} />
      <Route path="/production/crop/schemes" element={authRoute(isAuthenticated, <SchemeHubPage />)} />
      <Route path="/production/land/scheme-templates" element={authRoute(isAuthenticated, <SchemeTemplateCenterPage />)} />
      <Route path="/production/land/scheme-generate" element={authRoute(isAuthenticated, <SchemeGenerateWizardPage />)} />
      <Route path="/production/land/scheme-editor/:documentId" element={authRoute(isAuthenticated, <SchemeEditorPage />)} />
      <Route path="/production/land/scheme-export/:documentId" element={authRoute(isAuthenticated, <SchemeExportHubPage />)} />
      <Route path="/production/land/scheme-versions/:documentId" element={authRoute(isAuthenticated, <SchemeVersionPage />)} />
      <Route path="/production/land/scheme-ledger" element={authRoute(isAuthenticated, <ProjectLedgerPage />)} />
      <Route
        path="/smart-farm-cockpit"
        element={authRoute(isAuthenticated, <SmartFarmCockpitPage />)}
      />
      <Route
        path="/smart-farm-cockpit/zone/:zoneId"
        element={authRoute(isAuthenticated, <SmartFarmParcelRealtimePage />)}
      />

      <Route path="/production/crop/plans" element={authRoute(isAuthenticated, <PlantingPlanEntryPage />)} />
      <Route path="/production/crop/field-work-process" element={authRoute(isAuthenticated, <CropFieldWorkProcessPage />)} />
      <Route path="/production/crop/planted" element={authRoute(isAuthenticated, <PlantedCropsPage />)} />
      <Route path="/production/land/hub" element={authRoute(isAuthenticated, <LandManagementHubPage />)} />
      <Route path="/production/crop/growth-cycle" element={authRoute(isAuthenticated, <GrowthCyclePage />)} />
      <Route path="/production/crop/growth-budget" element={authRoute(isAuthenticated, <GrowthBudgetPage />)} />
      <Route path="/production/crop/warning-analysis" element={authRoute(isAuthenticated, <WarningAnalysisPage />)} />

      <Route path="/production/support/agricultural-materials" element={authRoute(isAuthenticated, <AgriculturalMaterialsPage />)} />
      <Route path="/production/support/materials-info" element={authRoute(isAuthenticated, <MaterialsInfoPage />)} />
      <Route path="/production/support/materials-management" element={authRoute(isAuthenticated, <MaterialsManagementPage />)} />
      <Route path="/production/crop/material-estimate" element={authRoute(isAuthenticated, <MaterialEstimatePage />)} />
      <Route path="/production/support/farm-procurement" element={authRoute(isAuthenticated, <FarmProcurementHubPage />)} />
      <Route path="/production/support/grain-storage" element={authRoute(isAuthenticated, <GrainStorageManagementPage />)} />

      <Route path="/production/field-work" element={authRoute(isAuthenticated, <FieldWorkOverviewPage />)} />
      <Route path="/production/field-work/ledger" element={authRoute(isAuthenticated, <FieldWorkLedgerPage />)} />
      <Route path="/production/crop/global-distribution" element={authRoute(isAuthenticated, <CropGlobalDistributionPage />)} />
      <Route path="/production/crop/growth-comparison" element={authRoute(isAuthenticated, <CropGrowthComparisonPage />)} />
      <Route path="/production/field-work/stage-plan" element={authRoute(isAuthenticated, <StageProtectionPlanPage />)} />

      <Route path="/production/field-work/plans" element={authRoute(isAuthenticated, <FieldManagementPage />)} />
      <Route path="/production/field-work/plan-manage" element={authRoute(isAuthenticated, <FieldPlanManagementPage />)} />
      <Route path="/production/field-work/operations" element={<Navigate to="/production/field-work" replace />} />
      {/* 作业任务功能已下线，旧 URL 保留参数并转到农事作业总览 */}
      <Route path="/production/field-work/tasks" element={<RedirectFieldTasksToOverview />} />
      <Route path="/production/crop/planning" element={<Navigate to="/production/crop/planted" replace />} />

      <Route path="/production/data-analysis" element={authRoute(isAuthenticated, <DataAnalysisPage />)} />
      <Route path="/production/environment-monitoring" element={<Navigate to="/production/land/env-monitoring" replace />} />
      <Route path="/production/network-trends" element={authRoute(isAuthenticated, <NetworkTrendAnalysisPage />)} />

      <Route path="/production/land/asset-management" element={authRoute(isAuthenticated, <AssetManagementPage />)} />
      <Route path="/production/asset-info" element={authRoute(isAuthenticated, <AssetInfoPage />)} />
      <Route path="/production/land/assets" element={authRoute(isAuthenticated, <LandAssetInfoPage />)} />
      <Route path="/production/land/:id" element={authRoute(isAuthenticated, <LandDetailPage />)} />
      <Route path="/production/asset-management-detail" element={authRoute(isAuthenticated, <ComprehensiveAssetManagementPage />)} />
      <Route path="/production/data-visualization" element={authRoute(isAuthenticated, <DataVisualizationPage />)} />
      <Route path="/production/field-work/sowing" element={authRoute(isAuthenticated, <SowingManagementPage />)} />
      <Route path="/production/field-work/fertilizing" element={authRoute(isAuthenticated, <FertilizationManagementPage />)} />
      <Route path="/production/field-work/machinery" element={authRoute(isAuthenticated, <MachineryOperationPage />)} />
      <Route
        path="/production/field-work/irrigation"
        element={authRoute(isAuthenticated, <IrrigationManagementUnifiedPage />)}
      />
      <Route
        path="/production/land/irrigation-design-map/:designId"
        element={authRoute(isAuthenticated, <IrrigationDesignMapPage />)}
      />
      <Route
        path="/production/land/irrigation-design-map/new"
        element={authRoute(isAuthenticated, <IrrigationDesignMapPage />)}
      />
      <Route
        path="/production/irrigation-equipment-catalog"
        element={authRoute(isAuthenticated, <IrrigationEquipmentCatalogPage />)}
      />
      <Route
        path="/production/land/irrigation-design-rule-config/:designId"
        element={authRoute(isAuthenticated, <IrrigationDesignRuleProfilePage />)}
      />
      <Route
        path="/production/land/irrigation-design-rotation-plan/:designId"
        element={authRoute(isAuthenticated, <IrrigationFertigationPlanPage />)}
      />
      <Route
        path="/production/land/irrigation-design-mode-config/:designId"
        element={authRoute(isAuthenticated, <RedirectIrrigationModeConfigToPlan />)}
      />
      <Route
        path="/production/land/irrigation-design-bom/:designId"
        element={authRoute(isAuthenticated, <IrrigationDesignBomPage />)}
      />
      <Route path="/production/field-work/weeding" element={authRoute(isAuthenticated, <WeedingManagementPage />)} />
      <Route path="/production/field-work/pest-control" element={authRoute(isAuthenticated, <DiseaseWarningPage />)} />

      <Route path="/production/field-work/pest-control/weather-warning" element={authRoute(isAuthenticated, <WeatherWarningPage />)} />
      <Route path="/production/field-work/pest-control/warning-reports" element={authRoute(isAuthenticated, <WarningReportsPage />)} />
      <Route path="/production/field-work/pest-control/prevention-advice" element={authRoute(isAuthenticated, <PreventionAdvicePage />)} />
      <Route path="/production/field-work/pest-control/notification-settings" element={authRoute(isAuthenticated, <NotificationSettingsPage />)} />
      <Route path="/production/field-work/pest-control/real-time-monitoring" element={authRoute(isAuthenticated, <RealTimeMonitoringPage />)} />
      <Route path="/production/field-work/pest-control/historical-analysis" element={authRoute(isAuthenticated, <HistoricalAnalysisPage />)} />

      <Route path="/production/asset-statistics" element={authRoute(isAuthenticated, <AssetStatisticsPage />)} />
      <Route path="/production/support/agricultural-material" element={authRoute(isAuthenticated, <AgriculturalMaterialPage />)} />
      {/* production-planning 已下线：年/季/月/品种/轮作/目标 → 种植计划 planted */}
      <Route path="/production/crop/production-planning" element={<Navigate to="/production/crop/planted" replace />} />
      <Route path="/production/crop/production-planning/*" element={<Navigate to="/production/crop/planted" replace />} />
      <Route path="/production/crop/planning-statistics" element={authRoute(isAuthenticated, <PlanningStatisticsPage />)} />
      <Route path="/production/field-work/warning-management" element={authRoute(isAuthenticated, <WarningManagementPage />)} />

      <Route path="/production/weather-disaster" element={<Navigate to="/weather-agronomy/disaster-warning" replace />} />
      <Route path="/production/trend-analysis" element={authRoute(isAuthenticated, <TrendAnalysisPage />)} />
      <Route path="/production/historical-data" element={authRoute(isAuthenticated, <HistoricalDataPage />)} />
      <Route path="/production/data-crawling" element={authRoute(isAuthenticated, <DataCrawlingPage />)} />
      <Route path="/production/data-analytics" element={authRoute(isAuthenticated, <DataAnalyticsPage />)} />
      <Route path="/production/global-monitoring" element={authRoute(isAuthenticated, <GlobalMonitoringPage />)} />

      <Route path="/production/crop/models/list" element={authRoute(isAuthenticated, <ModelListPage />)} />
      <Route path="/production/crop/models/ai-modeling" element={authRoute(isAuthenticated, <AIModelingPage />)} />
      <Route path="/production/crop/models/detail/:id" element={authRoute(isAuthenticated, <ModelDetailPage />)} />
      <Route path="/production/crop/models/parameter-config/:id" element={authRoute(isAuthenticated, <ModelParameterConfigPage />)} />

      <Route path="/production/field-work/tillage" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/production/field-work/thinning" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/production/field-work/fruit-thinning" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/production/field-work/harvesting" element={<Navigate to="/production/field-work" replace />} />
      <Route path="/production/field-work/calendar" element={authRoute(isAuthenticated, <CalendarPage />)} />
    </>
  );
}
